import jobHero from "../../../assets/job-hero.png";

const HeroSection = () => {
  return (
    <div className="px-6 lg:px-16 py-9">
      <div>
        <h1 className="head-text mb-2">Work with us</h1>
        <span className="max-w-[560px] mx-auto text-center text-paragraph text-lg">
          Join our team and revolutionize mobility with ZAP! Grow your career
          and make an impact with us.{" "}
        </span>
        <div className="my-8">
          <img src={jobHero} alt="" />
        </div>
      </div>
    </div>
  );
};

export default HeroSection;
